import { render, staticRenderFns } from "./Ocorrencias.vue?vue&type=template&id=231a7972&scoped=true&"
import script from "./Ocorrencias.vue?vue&type=script&lang=js&"
export * from "./Ocorrencias.vue?vue&type=script&lang=js&"
import style0 from "./Ocorrencias.vue?vue&type=style&index=0&id=231a7972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a7972",
  null
  
)

export default component.exports